export const SUBCONTRACTOR_ROUTES = {
  login: "/s/a7f3b2e1",
  retrieve: "/s/c9d8e5f4",
  form: "/s/b2e6a3d9",
};
